import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";

import { useRecoilValue } from "recoil";
import authProfileState from "../../states/authProfileState";

import ActionButtonLayout from "../layout/ActionButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";

import defineConf from "../../config/defineConf";

function TkPartnerPriceAgreementRsltUpdateButton(props) {
    const { t } = useTranslation();

    const { id, schema, grid, priceAgreementSelect, refresh, onSuccess, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);
    const [modifiedSchema, setModifiedSchema] = useState();
    const [formData, setFormData] = useState();

    const authProfile = useRecoilValue(authProfileState);

    const onOpen = () => {
        if (grid) {
            const modifiedSchema = cloneDeep(schema);
            const selectTarget = cloneDeep(grid.selectedItems[0]);

            if (modifiedSchema && selectTarget) {
                for (const column of modifiedSchema.columns) {
                    switch (column.name) {
                        case "partnerAgreementCompleted":
                            if (authProfile.companyInfo?.typeSupplyer || authProfile.companyInfo?.typeOutSourcing) {
                                column.hideInForm = false;
                            }
                            break;

                        case "relatedDoc":
                            if (authProfile.companyInfo?.typeSupplyer || authProfile.companyInfo?.typeOutSourcing) {
                                column.hideInForm = true;
                            }
                            break;

                        default:
                            column.disabled = true;
                            break;
                    }
                }

                setModifiedSchema(modifiedSchema);
            }

            setFormData({ ...selectTarget });
        }

        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onUpdateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        refresh.refresh();
    };

    return (
        <>
            <ActionButtonLayout id={id + "agreementRslt-update-button"} variant="outlined" onClick={onOpen} {...others}>
                {t("buttonName.agreementRsltUpdateButton")}
            </ActionButtonLayout>
            <AutoFormDialog
                id={id + "agreementRslt-update-dialog"}
                mode="edit"
                formId={id + "agreementRslt-update-form"}
                title={schema ? t(`dialog.title.${schema.name}.agreementRsltUpdate`) : ""}
                schema={modifiedSchema}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                doNotUseKeyAsUrlWhenUpdate
                modifyUrlCallback={(url) => {
                    return `/api/${schema.name}/doPartnerAgreementConfirm`;
                }}
                checkDisabledCallback={(formData, column) => {
                    if (column.name === "partnerAgreementCompleted") {
                        if (
                            (formData.agreementType === defineConf.agreementType.ORDER_PURCHASE_PRICE_AGREEMENT &&
                                !formData.partnerPrice) ||
                            (formData.agreementType === defineConf.agreementType.OUTSOURCING_PRICE_AGREEMENT &&
                                !formData.processTimeHour) ||
                            (formData.agreementType === defineConf.agreementType.ELECTRODE_PURCHASE_PRICE_AGREEMENT &&
                                !formData.partnerPrice) ||
                            formData.partnerAgreementCompleted === defineConf.agreementRslt.AGREEMENT_COMPLETED
                        ) {
                            column.disabled = true;
                        }
                    }
                }}
            />
        </>
    );
}

export default TkPartnerPriceAgreementRsltUpdateButton;
